var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jumpTem" },
    [
      _vm._t("banner"),
      _c(
        "el-form",
        {
          ref: _vm.mark + "_ruleForm",
          attrs: {
            model: _vm.form,
            "label-width": "120px",
            size: "small",
            rules: _vm.rules,
          },
        },
        [
          _vm.clientType === 1 && !_vm.isDefaultBanner
            ? _c(
                "el-form-item",
                { attrs: { label: "展示渠道", prop: "displayChannelList" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.form.displayChannelList,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "displayChannelList", $$v)
                        },
                        expression: "form.displayChannelList",
                      },
                    },
                    [
                      _c("el-checkbox", { attrs: { label: "1" } }, [
                        _vm._v("微信小程序"),
                      ]),
                      _c("el-checkbox", { attrs: { label: "2" } }, [
                        _vm._v("APP"),
                      ]),
                      _c("el-checkbox", { attrs: { label: "3" } }, [
                        _vm._v("云闪付"),
                      ]),
                      _c("el-checkbox", { attrs: { label: "4" } }, [
                        _vm._v("支付宝小程序"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "跳转页面", prop: "pageUrl" } },
            [
              _c("el-input", {
                directives: [{ name: "no-emoji", rawName: "v-no-emoji" }],
                staticStyle: { width: "300px" },
                attrs: { placeholder: "请输入链接" },
                model: {
                  value: _vm.form.pageUrl,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form,
                      "pageUrl",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "form.pageUrl",
                },
              }),
            ],
            1
          ),
          _vm.clientType === 1
            ? _c(
                "el-form-item",
                { attrs: { label: "跳转类型", prop: "pageUrlType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.pageUrlType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "pageUrlType", $$v)
                        },
                        expression: "form.pageUrlType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("外部链接"),
                      ]),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("乘客端内部页面"),
                      ]),
                      !_vm.isDefaultBanner
                        ? _c("el-radio", { attrs: { label: 3 } }, [
                            _vm._v("其他小程序（仅在微信小程序生效）"),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.form.pageUrlType === 3
            ? _c(
                "el-form-item",
                { attrs: { label: "APPID", prop: "appId" } },
                [
                  _c("el-input", {
                    directives: [{ name: "no-emoji", rawName: "v-no-emoji" }],
                    staticStyle: { width: "300px" },
                    attrs: { placeholder: "请输入APPID" },
                    model: {
                      value: _vm.form.appId,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "appId",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.appId",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.form.pageUrlType === 3
            ? _c(
                "el-form-item",
                { attrs: { label: "账号原始ID", prop: "appletOriginalId" } },
                [
                  _c("el-input", {
                    directives: [{ name: "no-emoji", rawName: "v-no-emoji" }],
                    staticStyle: { width: "300px" },
                    attrs: { placeholder: "请输入账号原始ID" },
                    model: {
                      value: _vm.form.appletOriginalId,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "appletOriginalId",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.appletOriginalId",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }